import { render } from "./chat-box-message.vue?vue&type=template&id=2ede408e&scoped=true&ts=true"
import script from "./chat-box-message.vue?vue&type=script&lang=ts"
export * from "./chat-box-message.vue?vue&type=script&lang=ts"

import "./chat-box-message.vue?vue&type=style&index=0&id=2ede408e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ede408e"]])

export default __exports__